module.exports = __webpack_public_path__ + "static/media/anaLogyThird.610a9d9d.svg";